import React, { Component, PropTypes } from 'react'
import { Button, Modal, Radio, ControlLabel } from 'react-bootstrap'
import Styles from './Existing.css'

class ReactivateConfirmModal extends Component {
  constructor (props) {
    super(props)
    this.state = ({
      shouldResetPointBalance: false
    })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ shouldResetPointBalance: false })
    }
  }

  render () {
    return (
      <div>
        <Modal
          style={{top: '120px'}}
          show={this.props.show}
          onHide={this._close}
          container={this}
          backdrop='static'
          dialogClassName={Styles['modal-dialog']}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '19px', color: '#ffffff', fontWeight: '300' }}>
              <div>Reactivate Loyalty Program</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={`${Styles['modal-body']} top10 bottom10`}>
            Are you sure you want to reactivate the loyalty program? The program will run again for all<br />
            outlets immediately. Please confirm the point configuration below:<br /><br />

            <div className='form-horizontal clearfix bottom20'>
              <ControlLabel className={Styles['point-balance-label']}>{'Reset customer\'s point balance?  '}</ControlLabel>
              <div style={{float: 'left'}}>
                <Radio className='point-balance-radio' onClick={this._onClickResetPointBalanceYes} name='radioGroup' checked={this.state.shouldResetPointBalance}>
                  Yes
                </Radio>
                <Radio className='point-balance-radio' onClick={this._onClickResetPointBalanceNo} name='radioGroup' checked={!this.state.shouldResetPointBalance}>
                  No
                </Radio>
              </div>
            </div>
            <span className={Styles['modal-highlighted-message']}>
              Please make sure all customers & outlets are aware of this reactivation.
            </span>
          </Modal.Body>
          <Modal.Footer>
            <Button style={{width: '100px'}} className='btn btn-default' onClick={this._close}>Cancel</Button>
            <Button style={{width: '100px'}} className='btn btn-primary' onClick={this._onClickReactivate}>Reactivate</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  _close = (e) => {
    e.stopPropagation()
    this.props.close()
  }

  _onClickReactivate = (e) => {
    e.stopPropagation()
    let data = {}
    if (this.state.shouldResetPointBalance) {
      data.reset = 'point'
    }
    this.props.confirm(data)
  }

  _onClickResetPointBalanceYes = (e) => {
    this.setState({
      shouldResetPointBalance: true
    })
  }

  _onClickResetPointBalanceNo = (e) => {
    this.setState({
      shouldResetPointBalance: false
    })
  }
}

ReactivateConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
}

export default ReactivateConfirmModal



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Existing/ReactivateConfirmModal.js